//CORE-ANGULAR
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
//CORE-CNM
import { GruposComponent } from './grupos.component';
//UTILITARIOS.
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  InputTextModule, DialogModule, DataTableModule, SharedModule, ButtonModule, GrowlModule, DropdownModule,
  MessagesModule, FileUploadModule, ConfirmDialogModule, InputTextareaModule,
  AutoCompleteModule,
  TabViewModule, PanelModule, CalendarModule, ConfirmationService, CheckboxModule, FieldsetModule, RadioButtonModule, MultiSelectModule
} from 'primeng/primeng';
import { KeyFilterModule } from 'primeng/keyfilter';

// Import ngx-barcode module
import { TableModule } from 'primeng/table';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/primeng';

@NgModule({
  declarations: [
    GruposComponent,

  ],
  imports: [
    TableModule,
    CommonModule,
    FormsModule,
    // ModuloGeneral,
    HttpModule,
    BrowserAnimationsModule,
    InputTextModule,
    DialogModule,
    DataTableModule,
    SharedModule,
    ButtonModule,
    GrowlModule,
    DropdownModule,
    MessagesModule,
    FileUploadModule,
    ConfirmDialogModule,
    InputTextareaModule,
    TabViewModule,
    PanelModule,
    CalendarModule,
    CheckboxModule,
    FieldsetModule,
    RadioButtonModule,
    KeyFilterModule,
    MultiSelectModule,
    AutoCompleteModule,
    BlockUIModule,
    ProgressSpinnerModule

  ],
  providers: [
  ],
  bootstrap: [],
  exports: [
    GruposComponent
  ]

})
export class GruposModule { }
